import React from 'react';

// Shared status badge tones so badges look like one family across screens.
const TONES = {
  neutral: 'bg-gray-100 text-gray-600 border-gray-200',
  info: 'bg-blue-100 text-blue-700 border-blue-200',
  success: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-100 text-amber-700 border-amber-200',
  danger: 'bg-rose-100 text-rose-700 border-rose-200',
  indigo: 'bg-indigo-100 text-indigo-700 border-indigo-200',
};

export const StatusBadge = ({ tone = 'neutral', children, className = '', testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${TONES[tone] || TONES.neutral} ${className}`}
  >
    {children}
  </span>
);

export default StatusBadge;
